"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SpinGlobal = _interopRequireDefault(require("./SpinGlobal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _SpinGlobal.default;
exports.default = _default;